<template>
    <!-- Container para toda la página: ******************************************************* -->
    <v-container fill-height fluid class="veterinarias">
        <!-- Layout para toda la página: *********************************************************** -->
        <v-layout align-center justify-center>
            <!-- Flex para la ventana: **************************************************************** -->
            <v-flex xs12 sm11 elevation-6>
                <div class="sub-window">
                    <v-toolbar dense dark color="purple accent-4">
                        <v-toolbar-title>CLose Buy&nbsp;&nbsp;</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items class="hidden-sm-and-down">
                            
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn text @click="onClose" v-on="on">
                                        <v-icon>mdi-close</v-icon>
                                    </v-btn>
                                </template>
                                <span>Cerrar</span>
                            </v-tooltip>
                        </v-toolbar-items>

                        <!-- Menú lateral para dispositivos con ventanas chicas: -->
                        <v-menu offset-y>
                            <template v-slot:activator="{ on }">
                                <v-btn icon v-on="on" class="hidden-md-and-up">
                                    <v-icon>mdi-dots-vertical</v-icon>
                                </v-btn>
                            </template>
                            <v-list color="grey lighten-4">
                                <v-divider></v-divider>
                                <v-list-item @click="onClose">
                                    <v-list-item-title>
                                        <v-icon color="red">mdi-close</v-icon>&nbsp; Cerrar
                                    </v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </v-toolbar>

                    <v-container fluid grid-list-md class="mx-auto">
                        <!-- Renglón único para lista de planes y card de plan seleccionado: -->
                        <v-row>
                            <v-col cols="5">
                                <v-row>
                                    <v-col cols="10">
                                        <v-text-field id="autocomplete" label="Dirección" v-model="coordinates" color="purple accent-4"></v-text-field>
                                    </v-col>
                                    <v-col cols="2">
                                        <v-btn class="mx-2" fab dark small color="purple accent-4"  @click="locatorButtonPressed">
                                            <v-icon dark>mdi-map-marker</v-icon>
                                        </v-btn>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="6">
                                        <v-select
                                            dense
                                            prepend-icon="mdi-store"
                                            :items="businessTypes"
                                            item-text="name"
                                            item-value="typeID"
                                            v-model="selectedTypeID"
                                            label="Tipo de Negocio"
                                            color="purple accent-4"
                                            item-color="purple accent-4"
                                        ></v-select>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-select
                                            dense
                                            prepend-icon="mdi-map-marker-radius"
                                            :items="radioKms"
                                            item-text="label"
                                            item-value="radioID"
                                            v-model="selectedRadioID"
                                            label="Radio"
                                            color="purple accent-4"
                                            item-color="purple accent-4"
                                        ></v-select>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="6">
                                        <v-btn
                                            text
                                            class="text-none purple--text text--accent-3"
                                            @click="onSearch"
                                        >Buscar</v-btn>
                                    </v-col>
                                </v-row> 
                                <v-row>
                                    <v-col cols="12">
                                        <v-list>
                                            <template v-for="(place, index) in places">
                                                <v-list-item :key="place.id">
                                                    <v-list-item-content>
                                                        <v-list-item-title v-text="place.name"></v-list-item-title>
                                                        <v-list-item-subtitle v-text="place.vicinity"></v-list-item-subtitle>
                                                    </v-list-item-content>
                                                </v-list-item>
                                                <v-divider v-if="index < places.length - 1"></v-divider>
                                            </template>
                                        </v-list>
                                    </v-col>
                                </v-row>      
                            </v-col>
                            <v-col cols="7">
                                    <div id="map">

                                    </div>
                            </v-col>
                        </v-row>

                        
                        
                        <!-- Termina renglón único para lista de planes y plan seleccionado -->
                    </v-container>
                    <!-- Termina container para lista de planes y plan seleccionado -->
                </div>
            </v-flex>
            <!-- Fin Flex para la ventana **************************************************************** -->
        </v-layout>
        <!-- Fin Layout para toda la página *********************************************************** -->
        <v-overlay :value="waitCursor">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-container>
    <!-- Fin container para toda la página ********************************************* -->
</template>

<script>
import { mapGetters } from 'vuex';
import axios from "axios";
import Vue from 'vue';
import InfoWindowComponent from '@/components/InfoWindow';

export default {
    name: 'planes',
    data() {
        return {
            bDense: true,
            drawer: false,
            address: "",
            lat: 0,
            lng: 0,
            type: "",
            radius: "",
            places: [],
            selectedTypeID: 0,
            businessTypes: [
                {
                    typeID: 1,
                    name: "Restaurantes",
                    type: "restaurant"
                },
                {
                    typeID: 2,
                    name: "Clínicas veterinarias",
                    type: "veterinary_care"
                }
            ],
            selectedRadioID: 0,
            radioKms: [
                {
                    radioID: 1,
                    label: "5 km",
                    value: "5"
                },
                {
                    radioID: 2,
                    label: "10 km",
                    value: "10"
                },
                {
                    radioID: 3,
                    label: "15 km",
                    value: "15"
                },
                {
                    radioID: 4,
                    label: "20 km",
                    value: "20"
                }
            ],
        };
    },
    mounted() {

       let autocomplete = new google.maps.places.Autocomplete(
        document.getElementById("autocomplete"),
        {
            bounds: new google.maps.LatLngBounds(
                new google.maps.LatLng(19.42847, -99.12766)
            )
        });

        autocomplete.addListener("place_changed", () => {
            let place = autocomplete.getPlace();
            console.log("place: ", place);
            this.showLocationOnMap(place.geometry.location.lat(), place.geometry.location.lng());
        })
    },
    created() {
 
        
    },

   
    
    
    methods: {
        onClose() {
            this.$router.push('/');
        },

        locatorButtonPressed() {
            if (navigator.geolocation)
            {
                navigator.geolocation.getCurrentPosition(
                    position => {
                        this.lat = position.coords.latitude;
                        this.lng = position.coords.longitude;
                        console.log("position = ", position);
                        this.getAddress(this.lat, this.lng)

                        this.showLocationOnMap(position.coords.latitude, position.coords.longitude);
                    },
                    error => {
                        console.log("Error getting location");
                    }
                );
            }
            else
            {
                console.log("Browser does not support geolocation API.");
            }
        },

        getAddress(lat, lng) {
            axios.get("https://maps.googleapis.com/maps/api/geocode/json?latlng="
            + lat + "," + lng 
            + "&key=AIzaSyA5fbXlj_ZTr8yGJM5TPKmOhPthQ5FjnSY")
            .then(response => {
                if (response.data.error_message)
                {
                    console.log(response.data.error_message);
                }
                else
                {
                    console.log(response.data);
                    this.address = response.data.results[0].formatted_address;
                }
            })
            .catch(error => {
                console.log(error.message);
            })
        },

        showLocationOnMap(latitude, longitude) {
            //Create a map object:
            let map = new google.maps.Map(document.getElementById("map"), {
                zoom: 15,
                center: new google.maps.LatLng(latitude, longitude),
                mapTypeID: google.maps.MapTypeId.ROADMAP
            });

            //Add a marker:
            new google.maps.Marker({
                position: new google.maps.LatLng(latitude, longitude),
                map: map
            })

        },

        onSearch() {
            for (let i = 0; i < this.businessTypes.length; i ++)
            {
                if (this.businessTypes[i].typeID === this.selectedTypeID)
                {
                    this.type = this.businessTypes[i].type;
                    break;
                }
            }

            for (let i = 0; i < this.radioKms.length; i ++)
            {
                if (this.radioKms[i].radioID === this.selectedRadioID)
                {
                    this.radius = this.radioKms[i].value;
                    break;
                }
            }

            const URL = 'https://cors-anywhere.herokuapp.com/https://maps.googleapis.com/maps/api/place/nearbysearch/json' +
                        '?location=' + this.lat + ',' + this.lng +
                        '&type=' +  this.type +
                        '&radius=' + this.radius * 1000 +
                        '&key=AIzaSyA5fbXlj_ZTr8yGJM5TPKmOhPthQ5FjnSY';
            

            console.log("URL = ", URL);

            axios.get(URL).then(response => {
                console.log("response = ", response);
                this.places = response.data.results;
                this.addLocationsToGoogleMaps();
            })
            .catch(error => {
                console.log(error.message);
            });
        },

        addLocationsToGoogleMaps() {
            var map = new google.maps.Map(document.getElementById("map"), {
                zoom: 15,
                center: new google.maps.LatLng(this.lat, this.lng),
                mapTypeId: google.maps.MapTypeId.ROADMAP
            });

            const markers = [];
            

            for (let i = 0; i < this.places.length; i ++)
            {
                const lat = this.places[i].geometry.location.lat;
                const lng = this.places[i].geometry.location.lng;

                let marker = new google.maps.Marker({
                    position: new google.maps.LatLng(lat, lng),
                    map: map
                });

                markers.push(marker);

                var InfoWindow = Vue.extend(InfoWindowComponent);

                google.maps.event.addListener(marker, "click", () => {
                    var instance = new InfoWindow({
                        propsData: {
                            name: this.places[i].name,
                            vicinity: this.places[i].vicinity
                        }
                    });
                    instance.$mount();
                    var new_infowindow = new google.maps.InfoWindow({content: instance.$el});
                    new_infowindow.open(map, marker);
                });

                
            }

            new markerClusterer.MarkerClusterer({
                map,
                markers
            });

        }        
    },
    computed:
    {
        ...mapGetters([
            'waitCursor'
        ]),

        coordinates() {
            return this.lat + ', ' + this.lng;
        }

       
    }
};
</script>

<style scoped>
.sub-window {
    /* background-color: #e0e0e0; */
    /*grey lighten-2 */
    background: rgba(224, 224, 224, 0.6);
}
.veterinarias {
    background: url('../assets/fondo2.jpg');
    background-size: cover;
    width: 100%;
    height: 100%;
}

.my-list-title {
    font-size: 15px;
    font-weight: bold;
}
.my-list-subtitle {
    font-size: 13px;
    font-weight: bold;
}
.my-list-header {
    font-size: 11px;
    font-weight: bold;
    background-color: #e0e0e0;
}
.my-list-item {
    min-height: 30px !important;
}

/* ***************Modificaciones para que no se parta el texto en v-card-text y en v-card-title (al parecer es un bug de vuetify):************* */
.v-card__text,
.v-card__title {
    word-break: normal; /* maybe !important  */
}

#map {
    /* position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0; */
    width: 100%;
    height: 600px;
    background: gray;
}
</style>